// utils/timeAgo.js
export const getTimeAgo = (timestamp) => {
  if (!timestamp) return "";

  const now = new Date();
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp); // handles Firestore Timestamp
  const seconds = Math.floor((now - date) / 1000);

  let interval = Math.floor(seconds / 31536000);
  if (interval >= 1)
    return interval === 1 ? "1 year ago" : `${interval} years ago`;

  interval = Math.floor(seconds / 2592000);
  if (interval >= 1)
    return interval === 1 ? "1 month ago" : `${interval} months ago`;

  interval = Math.floor(seconds / 86400);
  if (interval >= 1)
    return interval === 1 ? "Yesterday" : `${interval} days ago`;

  interval = Math.floor(seconds / 3600);
  if (interval >= 1)
    return interval === 1 ? "1 hour ago" : `${interval} hours ago`;

  interval = Math.floor(seconds / 60);
  if (interval >= 1)
    return interval === 1 ? "1 min ago" : `${interval} mins ago`;

  return "Just now";
};
